import React from 'react';
import ForgotPasswordContainer from '../components/forgotPassword.container';

const ForgotPasswordPage: React.FC = () => <ForgotPasswordContainer />;

export default ForgotPasswordPage;
